let nextErrorId = 0;

export interface ErrorOptions {
  error?;
  message?: string;
  source?;
  showNotification?: boolean;
  redirect?: boolean;
  redirectRoute?: string;
}

export class Error implements ErrorOptions {
  public readonly id: number = nextErrorId++;
  public readonly dateTime = Date.now();
  public error;
  public message = 'Error';
  public source;
  public showNotification = true;
  public redirect: boolean;
  public redirectRoute: string;

  constructor(options: ErrorOptions) {
    this.error = options.error;
    this.message = options.message || (this.error ? this.error.message : this.message);
    this.source = options.source;
    this.redirect = options.redirect;
    this.redirectRoute = options.redirectRoute;
    if (options.showNotification === false || !this.message) {
      this.showNotification = false;
    }
  }
}
